import { render, staticRenderFns } from "./newnoticeLeft.vue?vue&type=template&id=94d41772&scoped=true&"
import script from "./newnoticeLeft.vue?vue&type=script&lang=js&"
export * from "./newnoticeLeft.vue?vue&type=script&lang=js&"
import style0 from "./newnoticeLeft.vue?vue&type=style&index=0&id=94d41772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d41772",
  null
  
)

export default component.exports